import { Title } from "../components/Typography/Typography";
import styled, { css } from "styled-components/macro";
import { screenSize } from "../theme";
import { Link } from "react-router-dom";

export const PageWrapper = styled.div`
  width: 100%;
  min-width: 300px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.resolve("spacing_xl")}
    ${({ theme }) => theme.resolve("spacing_xl")}
    ${({ theme }) => theme.resolve("spacing_xl")};
  .ql-editor {
    height: auto !important;
  }
`;

export const HeaderBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  & > *[data-alignright] {
    margin-left: auto;
  }
  .searchBar {
    flex: 1 1 100%;
    order: 10;
    max-width: 100%;
  }

  @media ${screenSize.medium} {
    flex-wrap: wrap;
    & > *[data-alignright] {
      margin-left: 0 !important;
    }
  }
`;

export const PortfolioSearch = styled(HeaderBar)`
  margin-top: 10px;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 10px;
  .searchBar {
    max-width: 515px;
  }
  @media ${screenSize.medium} {
    margin-top: ${({ theme }) => theme.resolve("spacing_none")};
  }
`;

export const FiltersWrapper = styled.div`
  min-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
  & > * {
    margin-right: ${({ theme }) => theme.resolve("spacing_md")};
    margin-bottom: 10px;
  }
  & > *[data-alignright] {
    margin-left: auto;
  }

  @media ${screenSize.mLarge} {
    width: 100%;
  }

  @media ${screenSize.medium} {
    margin: 10px 0 5px;
    flex-wrap: wrap;
    width: 100%;
    button {
      white-space: nowrap;
      text-align: center;
    }

    & > * {
      margin-right: 5px;
      margin-bottom: ${({ theme }) => theme.resolve("spacing_md")};
    }
    & > *[data-alignright] {
      margin-left: 0 !important;
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const PortfolioContentLayout = styled.div`
  z-index: 1;
  width: 100%;
  display: Flex;
  flex-direction: row;
  position: relative;
  .gutter {
    background-color: ${(props: any) => props.theme.primaryBorder};
    opacity: 0.5;
    height: 100%;
    transition: all linear 0.2s;
    border-right: ${({ theme }) => theme.resolve("border_2xl")} solid
      ${(props: any) => props.theme.colors.white};
    border-left: ${({ theme }) => theme.resolve("border_2xl")} solid
      ${(props: any) => props.theme.colors.white};
    width: 7px;
    cursor: col-resize;
    &:hover {
      box-shadow: 0 0 5px ${(props: any) => props.theme.colors.black};
      transform: scale(1.1, 1);
      opacity: 1;
    }
  }
  @media ${screenSize.large} {
    flex-direction: column;
    padding-left: 0;
    .gutter {
      display: none;
    }
  }
`;
interface IProductListProps {
  gridView?: boolean;
}
export const ProductListMainWrapper = styled.div<IProductListProps>`
  width: 100%;
  height: 100%;
  min-width: 200px;
  max-width: ${({ gridView }) => (gridView ? "100%" : "42%")};
  display: ${({ gridView }) => (gridView ? "grid" : "flex")};
  grid-template-columns: ${({ gridView }) =>
    gridView ? "repeat(auto-fill, minmax(280px, 1fr))" : "none"};
  gap: ${({ gridView, theme }) =>
    gridView ? theme.resolve("spacing_xl") : "0"};
  flex-direction: ${({ gridView }) => (gridView ? "row" : "column")};
  flex-wrap: ${({ gridView }) => (gridView ? "wrap" : "column")};
  align-items: ${({ gridView }) => (gridView ? "stretch" : "center")};
  padding: 0 15px 0 0;
  align-content: flex-start;
  justify-content: normal;

  @media ${screenSize.large} {
    flex-direction: row;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    overflow-y: auto;
    position: relative;
    grid-template-columns: ${({ gridView }) =>
      gridView ? "repeat(auto-fill, minmax(250px, 1fr))" : "none"};
  }

  @media ${screenSize.medium} {
    grid-template-columns: ${({ gridView }) =>
      gridView ? "repeat(auto-fill, minmax(200px, 1fr))" : "none"};
  }

  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const baseProductListStyles = css<IProductListProps>`
  display: block;
  width: ${({ gridView }) => (gridView ? "31%" : "100%")};
  min-height: 120px;
  margin: ${({ theme, gridView }) =>
    gridView ? `${theme.resolve("spacing_none")} 15px 15px 0` : "0 0 15px 0"};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${(props: any) => props.theme.primaryBorder};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  padding: ${({ theme }) => theme.resolve("spacing_2xl")};
  justify-content: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  h3 {
    margin: 0 0 10px 0;
  }
  &:last-child {
    margin-bottom: ${({ gridView }) => (gridView ? "0" : "15px")};
  }
  @media ${screenSize.large} {
    width: ${({ gridView }) => (gridView ? "45%" : "100%")};
    max-width: 340px;
    margin-right: 15px;
    padding: 10px 15px;
    &:last-child {
      margin-right: 0;
    }
  }

  @media ${screenSize.large} {
    min-width: ${({ gridView }) => (gridView ? "200px" : "250px")};
  }
  @media ${screenSize.medium} {
    width: 100%;
    max-width: 100%;
  }
  text-decoration: none;
`;

export const ProductListItemWrapper = styled(Link)<IProductListProps>`
  ${baseProductListStyles}
`;

export const SelectedProductListItemWrapper = styled.div<IProductListProps>`
  ${baseProductListStyles}
  background: ${(props) => props.theme.primaryButtonBG};
  border-color: ${(props) => props.theme.selectedBorder};
`;

export const ProductContentWrapper = styled.div`
  width: 100%;
  min-width: 57%;
  margin-left: ${({ theme }) => theme.resolve("spacing_2xl")};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${(props: any) => props.theme.secondaryBorder};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
  padding: 35px;
  min-height: 500px;
  height: fit-content;
  @media ${screenSize.large} {
    margin-left: 0;
    margin-top: 25px;
    width: 100% !important;
  }
  @media ${screenSize.small} {
    padding: 14px;
    min-height: 0;
  }
`;

// TODO can this be deleted
export const Card = styled.div`
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  border: solid 0.6px ${(props) => props.theme.primaryBorder};
  background-color: ${(props) => props.theme.secondaryBG};
  font-size: 13px;
  padding: 15px 15px;
  width: 100%;
`;

export const AuthPage = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AuthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 450px;
  outline: ${({ theme }) =>
    `${theme.resolve("border_2xl")} solid ${theme.publicNavBorder}`};
  @media ${screenSize.medium} {
    outline: none;
  }
  border-radius: ${({ theme }) => theme.resolve("radius_xl")};
  margin: 0 auto;
  padding: 35px 0;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const AuthContainer = styled(AuthWrapper)`
  form {
    width: 100%;
    max-width: ${({ theme }) => theme.resolve("width_xxs")};
    button {
      margin-top: 15px;
      text-shadow: 0 0 5px #00000040;
    }
    .errorMessage {
      margin-top: 5px;
    }
  }
`;

export const AuthLogo = styled("img")`
  max-width: 160px !important;
  margin: 30px auto;
`;

export const HomePageTitle = styled(Title)`
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  letter-spacing: -1px;
  margin-bottom: ${({ theme }) => theme.resolve("spacing_2xl")};
  margin-top: 10px;
  @media ${screenSize.small} {
    font-size: ${({ theme }) => theme.fontSizes.xl};
    font-weight: ${({ theme }) => theme.fontWeights.small};
    margin-bottom: 10px;
  }
`;

export const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  flex-direction: column;
  align-content: center;
  width: 100%;
`;

/**
 * User for forgot-password and forgot-username
 */
export const AuthForgotContainer = styled.div`
  display: flex;
  justify-content: center;
  a {
    color: ${({ theme }) => theme.primaryButtonBG};
    font-size: ${({ theme }) => theme.fontSizes.small};
  }
`;

export const GetStartedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: ${({ theme }) => theme.resolve("spacing_5xl")} 0;
`;

export const SectionDivider = styled.div`
  height: 1px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: ${({ theme }) =>
    `${theme.resolve("border_md")} solid ${theme.publicNavBorder}`};
  position: relative;
  margin: 0 0 30px;
  > * {
    position: relative;
    top: 10px;
    text-align: center;
    background: ${({ theme }) => theme.colors.white};
    width: 80px;
    height: 40px;
  }
`;
